﻿import { Component } from './Components.js';

export class FlexiSide extends Component {
  constructor(name, drawingService, apiFlexiSide) {
    super(name, drawingService, apiFlexiSide);
  }
  preFactorySetup(config) {
    super.preFactorySetup(config);
    this.materialIdPrefix = 'FlexiSide';
  }

  createDisplayObject() {
    return this.createMaterialObject();
  }

  acceptVisitor(visitor) {
    return visitor.visitFlexiSide(this);
  }
}

export class FlexiSectionContent extends Component {
  createDisplayObject() {
    return this.createMaterialObject();
  }
}

class RodWithBrackets extends FlexiSectionContent {
}

export class HangRodWithBrackets extends RodWithBrackets {
  constructor(name, drawingService, apiHangRod) {
    super(name, drawingService, apiHangRod);
  }
  preFactorySetup(config) {
    super.preFactorySetup(config);
    this.materialIdPrefix = 'HangRod';
  }

  acceptVisitor(visitor) {
    return visitor.visitHangRodWithBrackets(this);
  }
}

export class SupportRodWithBrackets extends RodWithBrackets {
  constructor(name, drawingService, apiSupportRod) {
    super(name, drawingService, apiSupportRod);
  }
  preFactorySetup(config) {
    super.preFactorySetup(config);
    this.materialIdPrefix = 'SupportRod';
  }

  acceptVisitor(visitor) {
    return visitor.visitSupportRodWithBrackets(this);
  }
}

export class FlexiBasketAndTracks extends FlexiSectionContent {
  constructor(name, drawingService, apiBasket) {
    super(name, drawingService, apiBasket);
  }
  preFactorySetup(config) {
    super.preFactorySetup(config);
    this.materialIdPrefix = 'FlexiBasketAndTracks';
  }

  acceptVisitor(visitor) {
    return visitor.visitFlexiBasketAndTracks(this);
  }
}

export class MeshBasketAndTracks extends FlexiSectionContent {
  constructor(name, drawingService, apiBasket) {
    super(name, drawingService, apiBasket);
  }
  preFactorySetup(config) {
    super.preFactorySetup(config);
    this.materialIdPrefix = 'MeshBasketAndTracks';
  }

  acceptVisitor(visitor) {
    return visitor.visitMeshBasketAndTracks(this);
  }
}

class BaseShelf extends FlexiSectionContent {
}

export class FlexiShelf extends BaseShelf {
  constructor(name, drawingService, apiFlexiShelf) {
    super(name, drawingService, apiFlexiShelf);
    this.metalFinish = apiFlexiShelf.metalF;
  }
  preFactorySetup(config) {
    super.preFactorySetup(config);
    this.materialIdPrefix = 'FlexiShelf';
  }

  getSecondaryFinish() {
    // Some types of shelves have metal finish (i.e. wired shelves)
    return this.metalFinish;
  }

  setSecondaryFinish(value) {
    // Some types of shelves have metal finish (i.e. wired shelves)
    this.metalFinish = value;
  }

  addToMaterialIdList(list) {
    super.addToMaterialIdList(list);
    if (this.metalFinish) {
      if (this.materialIdPrefix) {
        list[this.materialIdPrefix + this.drawingService.materialPrefixDelim + this.metalFinish] = true;
      } else {
        list[this.metalFinish] = true;
      }
    }
  }

  acceptVisitor(visitor) {
    return visitor.visitFlexiShelf(this);
  }
}

export class TopShelf extends BaseShelf {
  constructor(name, drawingService, apiTopShelf) {
    super(name, drawingService, apiTopShelf);
  }
  preFactorySetup(config) {
    super.preFactorySetup(config);
    this.materialIdPrefix = 'TopShelf';
  }

  acceptVisitor(visitor) {
    return visitor.visitTopShelf(this);
  }
}

export class FlexiSectionContents extends Component {
  constructor(name, drawingService, apiContents, config) {
    super(name, drawingService, apiContents, config);
    /*this.items =*/ this.addApiComponents('Content', this.apiProduct.items);
  }

  createDisplayObject() {
    return this.createContainer();
  }

  iterateContentsUsingPrimaryFinish(onEach) {
    this.components.forEach(comp => {
      // The flexi-section's primary finish is a "wood", while rods and baskets' primary finish is "metal".
      if ((comp instanceof RodWithBrackets) || (comp instanceof FlexiBasketAndTracks) ||
        (comp instanceof MeshBasketAndTracks)) {
        // Skip! The component doesn't have a "wood" finish.
      } else {
        onEach(comp); // The component's primary finish is the "wood" finish
      }
    });
  }

  iterateContentsUsingSecondaryFinish(onEach) {
    this.components.forEach(comp => {
      // The flexi-section's primary finish is a "wood", while rods and baskets' primary finish is "metal".
      if ((comp instanceof RodWithBrackets) || (comp instanceof FlexiBasketAndTracks) ||
        (comp instanceof MeshBasketAndTracks)) {
        onEach(comp, /*usePrimaryFinish:*/ true); // The component's primary finish is the metal finish
      } else if (comp instanceof FlexiShelf) {
        // Shelves might have both primary and secondary finish.
        onEach(comp, /*usePrimaryFinish:*/ false); // The component's secondary finish is the metal finish
      } else {
        // The component doesn't have a secondary/metal finish
      }
    });
  }

  /**
   * Adds each content's primary finishes to the finishes array parameter. Note, secondary finishes
   * should not be added (e.g. metal finish).
   */
  addToPrimaryFinishArray(finishes) {
    this.iterateContentsUsingPrimaryFinish(content => content.addToPrimaryFinishArray(finishes));
  }

  /** Adds each content's secondary finish (i.e. metal finish) to the finishes array parameter. */
  addToSecondaryFinishArray(finishes) {
    this.iterateContentsUsingSecondaryFinish((content, usePrimaryFinish) => {
      if (usePrimaryFinish) {
        content.addToPrimaryFinishArray(finishes);
      } else {
        content.addToSecondaryFinishArray(finishes);
      }
    });
  }

  doReplaceFinishesRecursively(newFinish, onChanged) {
    this.iterateContentsUsingPrimaryFinish(content => content.doReplaceFinishesRecursively(newFinish));
    this.replaceFinish(newFinish, onChanged);
  }

  doReplaceSecondaryFinishesRecursively(newFinish, onChanged) {
    this.iterateContentsUsingSecondaryFinish((content, usePrimaryFinish) => {
      if (usePrimaryFinish) {
        content.doReplaceFinishesRecursively(newFinish);
      } else {
        content.doReplaceSecondaryFinishesRecursively(newFinish);
      }
    });
    this.replaceSecondaryFinish(newFinish, onChanged);
  }

  assignModificationsTo(destApiProduct) {
    return Component.assignArrayModificationsTo(destApiProduct, 'contents', this.components, /*assignType:*/ true);
  }

  iterate(iterator) {
    this.components.forEach(content => iterator.iterate(content));
  }

  visitChildren(visitor) {
    this.components.forEach(content => visitor.visit(content));
  }

  acceptVisitor(visitor) {
    return visitor.visitFlexiSectionContents(this);
  }
}

class ClosetModule extends Component {
  createDisplayObject() {
    return this.createContainer();
  }

  /**
   * Adds each component's primary finishes to the finishes array parameter. Note, secondary finishes
   * should not be added (e.g. metal finish).
   */
  addToPrimaryFinishArray(finishes) {
    this.components.forEach(item => item.addToPrimaryFinishArray(finishes));
  }

  /** Adds each component's secondary finishes to the finishes array parameter (i.e. metal finish). */
  addToSecondaryFinishArray(finishes) {
    this.components.forEach(item => item.addToSecondaryFinishArray(finishes));
  }

  /** Used by Iterator subclasses, e.g. DetachFromDomIterator. */
  iterate(iterator) {
    this.components.forEach(component => iterator.iterate(component));
  }

  /**
   * Used by Visitor subclasses when the visitor needs to recurse into children of the currently
   * visited class.
   */
  visitChildren(visitor) {
    this.components.forEach(component => visitor.visit(component));
  }
}

export const FloorModuleAlign = {
  Left: 'Left',
  Center: 'Center',
  Right: 'Right',
  Fill: 'Fill',
  Free: 'Free'
};

class FloorModule extends ClosetModule {
  constructor(name, drawingService, apiModule) {
    super(name, drawingService, apiModule);
    this.align = apiModule.align || FloorModuleAlign.Left;
    this.innerW = apiModule.innerW || 0;
    this.metalFinish = apiModule.metalF;
    this.heightType = apiModule.heightType;
    if (apiModule.leftSide) {
      this.leftSide = new FlexiSide('Left Side', this.drawingService, apiModule.leftSide);
      this.addComponent(this.leftSide);
    }
    if (apiModule.rightSide) {
      this.rightSide = new FlexiSide('Right Side', this.drawingService, apiModule.rightSide);
      this.addComponent(this.rightSide);
    }
  }

  getSecondaryFinish() {
    // Some types of shelves have metal finish (i.e. wired shelves)
    return this.metalFinish;
  }

  setSecondaryFinish(value) {
    // Some types of shelves have metal finish (i.e. wired shelves)
    this.metalFinish = value;
  }

  assignModificationsTo(destApiProduct) {
    let isModified = super.assignModificationsTo(destApiProduct); // Call super to get any changes to finish

    /* TODO: For now we assume heightType, innerW, and align are modified and handled directly in
     * the UI, but we really should check and assign each of these here. */

    if (this.metalFinish !== this.apiProduct.metalF) {
      destApiProduct.metalF = this.metalFinish;
      isModified = true;
    }

    const destLeftSide = {};
    const isLeftSideModified = this.leftSide && this.leftSide.assignModificationsTo(destLeftSide);
    if (isLeftSideModified) {
      destApiProduct.leftSide = destLeftSide;
    }
    const destRightSide = {};
    const isRightSideModified = this.rightSide && this.rightSide.assignModificationsTo(destRightSide);
    if (isRightSideModified) {
      destApiProduct.rightSide = destRightSide;
    }
    return isModified || isLeftSideModified || isRightSideModified;
  }
}

export class FlexiSection extends FloorModule {
  constructor(name, drawingService, apiSection) {
    super(name, drawingService, apiSection);
    this.contents = new FlexiSectionContents('Contents', this.drawingService, apiSection.contents);
    this.addComponent(this.contents);
  }

  assignModificationsTo(destApiProduct) {
    let isModified = super.assignModificationsTo(destApiProduct); // Call super to get any changes to finish

    const destContents = {
      //"type" property only needs to be assigned if/when type can be modified or different among the children (e.g. section contents)
      //type: this.core.type
    };
    const isContentsModified = this.contents.assignModificationsTo(destContents);
    if (isContentsModified) {
      destApiProduct.contents = destContents;
    }
    return isModified || isContentsModified;
  }

  acceptVisitor(visitor) {
    return visitor.visitFlexiSection(this);
  }
}

class StandardModule extends FloorModule {
  constructor(name, drawingService, apiStandardModule) {
    super(name, drawingService, apiStandardModule);
    this.floorModules = this.addApiComponents('Floor Module', this.apiProduct.floorModules);
    this.otherComponents = this.addApiComponents('Component', this.apiProduct.otherComponents);
  }

  assignModificationsTo(destApiProduct) {
    let isModified = super.assignModificationsTo(destApiProduct); // Call super to get any changes to finish

    const areFloorModulesModified = Component.assignArrayModificationsTo(destApiProduct, 'floorModules', this.hangRods);
    const areOtherComponentsModified = Component.assignArrayModificationsTo(destApiProduct, 'otherComponents', this.otherComponents);

    return isModified || areFloorModulesModified || areOtherComponentsModified;
  }
}

export class TopShelfModule extends ClosetModule {
  constructor(name, drawingService, apiShelfModule) {
    super(name, drawingService, apiShelfModule);
    /*this.shelves =*/ this.addApiComponents('Shelf', this.apiProduct.shelves);
  }

  assignModificationsTo(destApiProduct) {
    let isModified = super.assignModificationsTo(destApiProduct); // Call super to get any changes to finish
    const areShelvesModified = Component.assignArrayModificationsTo(destApiProduct, 'shelves', this.components);
    return isModified || areShelvesModified;
  }

  acceptVisitor(visitor) {
    return visitor.visitTopShelfModule(this);
  }
}

export class HangRodModule extends StandardModule {
  constructor(name, drawingService, apiHangRodModule) {
    super(name, drawingService, apiHangRodModule);
    this.hangRods = this.addApiComponents('Hang rod', this.apiProduct.hangRods);
    this.supportRods = this.addApiComponents('Support rod', this.apiProduct.supportRods);
    this.shelves = this.addApiComponents('Shelf', this.apiProduct.shelves);
  }

  doReplaceFinishesRecursively(newFinish, onChanged) {
    this.components.forEach(comp => {
      /* The primary finish is a "wood", but any rod finishes are "metal".
       * Hence, skip rods here: */
      if (!(comp instanceof RodWithBrackets) && !(comp instanceof SupportRodWithBrackets)) {
        comp.doReplaceFinishesRecursively(newFinish);
      }
    });
    this.replaceFinish(newFinish, onChanged);
  }

  doReplaceSecondaryFinishesRecursively(newFinish, onChanged) {
    this.components.forEach(comp => {
      if ((comp instanceof RodWithBrackets) || (comp instanceof FlexiBasketAndTracks) ||
        (comp instanceof MeshBasketAndTracks)) {
        comp.doReplaceFinishesRecursively(newFinish);
      } else {
        comp.doReplaceSecondaryFinishesRecursively(newFinish);
      }
    });
    this.replaceSecondaryFinish(newFinish, onChanged);
  }

  assignModificationsTo(destApiProduct) {
    let isModified = super.assignModificationsTo(destApiProduct); // Call super to get any changes to finish

    const areHangRodsModified = Component.assignArrayModificationsTo(destApiProduct, 'hangRods', this.hangRods);
    const areSupportRodsModified = Component.assignArrayModificationsTo(destApiProduct, 'supportRods', this.supportRods);

    return isModified || areHangRodsModified || areSupportRodsModified;
  }

  acceptVisitor(visitor) {
    return visitor.visitHangRodModule(this);
  }
}

export class ClosetOrganizer extends StandardModule {
  constructor(name, drawingService, apiClosetOrganizer) {
    super(name, drawingService, apiClosetOrganizer);
    this.topShelfModule = new TopShelfModule('Topshelf Module', this.drawingService, apiClosetOrganizer.topShelfModule);
    this.addComponent(this.topShelfModule);
  }

  assignModificationsTo(destApiProduct) {
    let isModified = super.assignModificationsTo(destApiProduct); // Call super to get any changes to finish

    const destTopShelfModule = {
      //"type" property only needs to be assigned if/when type can be modified or different among the children (e.g. section contents)
      //type: this.core.type
    };
    const isModuleModified = this.topShelfModule.assignModificationsTo(destTopShelfModule);
    if (isModuleModified) {
      destApiProduct.topShelfModule = destTopShelfModule;
    }
    return isModified || isModuleModified;
  }

  acceptVisitor(visitor) {
    return visitor.visitClosetOrganizer(this);
  }
}
